import { gql } from "@outschool/ui-apollo";

export const SECTION_MESSAGES_SUMMARY_QUERY = gql`
  query SectionMessagesSummary($sectionUid: ID!) {
    section(uid: $sectionUid) {
      uid
      unreadThreadsCount
      learnerUnreadCommentThreadsCount
      leader {
        uid
        name
        photo
      }
    }
  }
`;

export const THREADS_FOR_SECTION_QUERY = gql`
  query ThreadsForSection($sectionUid: ID!, $searchQuery: String) {
    section(uid: $sectionUid) {
      uid
      end_time
      unreadThreadsCount
      learnerUnreadFeedbackAssignmentClassPostUids
      threads(searchQuery: $searchQuery) {
        uid
        classPost {
          uid
          title
          blockType
        }
        learningAssignmentClassPost {
          uid
          title
        }
        latestMessage {
          uid
          messageContent {
            uid
            text
            attachments {
              uid
              file {
                mimetype
              }
            }
            video {
              uid
            }
          }
          sentAt
        }
        unreadCount
      }
      learnerPublicCommentThreads(searchQuery: $searchQuery) {
        uid
        isRead
        classPost {
          uid
          title
        }
        latestComment {
          uid
          sendAt
          sender {
            uid
            name
            photo
            avatar
            isLearner
          }
          messageContent {
            uid
            text
            attachments {
              uid
              file {
                mimetype
              }
            }
            video {
              uid
            }
          }
        }
      }
      learnerAssignmentPublicCommentThreads(searchQuery: $searchQuery) {
        uid
        isRead
        assignmentClassPost {
          uid
          title
        }
        latestComment {
          uid
          sendAt
          sender {
            uid
            name
            photo
            avatar
            isLearner
          }
          messageContent {
            uid
            text
            attachments {
              uid
              file {
                mimetype
              }
            }
            video {
              uid
            }
          }
        }
      }
      leader {
        uid
        name
        photo
      }
    }
  }
`;
